module.exports = __webpack_public_path__ + "static/media/chaos.3a5826fd.jpg";